/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getBusRoutesList: (params) => {
    return axios.get(API_ENDPOINTS.GET_BUS_ROUTES_LIST, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      params,
    });
  },
  createBusRoute: (data) => {
    return axios.post(API_ENDPOINTS.GET_BUS_ROUTES_LIST, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  getBusRouteById: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_BUS_ROUTES_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  updateBusRoute: (id, data) => {
    return axios.patch(`${API_ENDPOINTS.GET_BUS_ROUTES_LIST}/${id}`, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  deleteBusRoute: (id) => {
    return axios.delete(`${API_ENDPOINTS.GET_BUS_ROUTES_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
};
